// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#scale-line[data-v-a7b7f938]{min-width:100px;margin:5px}", ""]);
// Exports
module.exports = exports;
